import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Typography,
  Button,
  Modal,
  TextField,
  Checkbox,
  FormControlLabel,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  IconButton,
} from "@mui/material";
import {
  getListProblemSolution,
  insertTimeTimeWork,
  fullDataPiece,
  setLog,
  getElapsedTimeFromServer,
} from "../../services/ConnectDataBase.js";
import { updateInfoData } from "../../redux/reducers";
import { useSelector, useDispatch } from "react-redux";
import {
  SCREEN_IDS,
  typeConnect,
  backgroundColor2,
} from "../../constants/Constants.js";
import CronometroMonitor from "./ComponentCronometroMonitor.js";
import {
  getListOptionsTimeWork,
  getListOptionsProblemAndSolutions,
  getArrayInfoDataUpdate,
} from "../../services/Functions";
import ComponentObservaciones from "../Info/ComponentObservaciones.js";
import { ContactSupportOutlined } from "@mui/icons-material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { translateText } from "../../translations/translationService";
import { BRAND_COLORS, BACKGROUND_COLORS, STATUS_COLORS, SIMPLIFIED_CRONOMETRO_COLORS } from "../../style/colors.js";
import { notify } from "../../services/ui/notify";

const SimplifiedCronometro = ({
  screen,
  listData,
  po,
  mo,
  fulldata,
  totalIncidencias,
  navigation,
}) => {
  const dispatch = useDispatch();
  const [isRunning, setIsRunning] = useState(false);
  const [elapsedTime, setElapsedTime] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [finishModalVisible, setFinishModalVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [listOption, setListOption] = useState([]);
  const [showIncidencia, setShowIncidencia] = useState(false);
  const [pieceCount, setPieceCount] = useState(""); // Número de piezas terminadas
  const [incidenciaCount, setIncidenciaCount] = useState(""); // Número de piezas de incidencia
  const [selectedIncidentOption, setSelectedIncidentOption] = useState(null);
  const [startDate, setStartDate] = useState(null); // Fecha de inicio
  const [tiempoTeorico, setTiempoTeorico] = useState(null);
  const currentScreenId = SCREEN_IDS.GENERAL;
  const startTimeRef = useRef(null);
  const timerRef = useRef(null);
  const name = useSelector((state) => state.user.name);
  const lang = useSelector((state) => state.lang.value);
  const team = useSelector((state) => state.user.team);
  const cod_team = useSelector((state) => state.user.cod_team);
  const Options = getListOptionsTimeWork(listData);
  const OptionIncident = getListOptionsProblemAndSolutions(listOption);
  const [isProcessing, setIsProcessing] = useState(false);
  const [comment, setComment] = useState("");

  const [resolverFinalizar, setResolverFinalizar] = useState(null);
  const [confirmarFinalizacionVisible, setConfirmarFinalizacionVisible] =
    useState(false);

  const cantidadTotal = parseFloat(fulldata.cantidad) || 0;
  const cantidadFabricada = parseFloat(fulldata.cantidad_fabricada) || 0;
  const cantidadTerminada = parseFloat(fulldata.cantidad_terminada) || 0;

  const cantidadRestante = cantidadTotal - cantidadTerminada;

  const showAlert = (title, message) => {
    const fullMessage = `${title}: ${message}`;
    if (String(title).toLowerCase() === "error") {
      notify.error(fullMessage);
    } else {
      notify.warn(fullMessage);
    }
  };

  async function getListOptionsProblemQuality() {
    try {
      const options = await getListProblemSolution(mo, 5, cod_team, "list");
      setListOption(options);
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    getListOptionsProblemQuality();
  }, []);

  useEffect(() => {
    const unsubscribe = navigation.addListener("beforeRemove", (e) => {
      if (!isRunning) return;

      e.preventDefault();
      notify.warn("¡Cronómetro activo! Debes pararlo antes de salir.");
    });

    return () => {
      unsubscribe();
    };
  }, [navigation, isRunning]);

  useEffect(() => {
    if (isRunning) {
      startTimeRef.current = Date.now() - elapsedTime;

      timerRef.current = setInterval(() => {
        setElapsedTime(Date.now() - startTimeRef.current);
      }, 1000);

      const syncWithServer = setInterval(async () => {
        const serverTime = await getElapsedTimeFromServer(
          currentScreenId,
          "SyncTimeWithServer",
          mo,
          startDate
        );

        if (serverTime !== null) {
          setElapsedTime(serverTime * 60000);
          console.log(
            "Tiempo sincronizado con el servidor:",
            serverTime,
            "minutos"
          );
        }
      }, 60000);

      return () => {
        clearInterval(timerRef.current);
        clearInterval(syncWithServer);
        timerRef.current = null;
      };
    }
  }, [isRunning]);

  const formatTime = (milliseconds) => {
    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    const pad = (n) => (n < 10 ? "0" + n : n);
    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  const saveCronometroState = () => {
    const cronometroState = {
      isRunning,
      elapsedTime,
      startDate,
      mo,
      process: selectedOption,
    };
    localStorage.setItem("currentCronometro", JSON.stringify(cronometroState));
    console.log("Estado del cronómetro guardado:", cronometroState);
  };

  const handleStart = () => {
    if (totalIncidencias >= cantidadTotal) {
      showAlert(
        "Información",
        "No se puede iniciar el proceso porque todas las piezas tienen incidencias."
      );
      return;
    }

    if (cantidadFabricada >= cantidadTotal) {
      showAlert("Información", "Todas las piezas ya han sido fabricadas.");
      return;
    }
    setModalVisible(true);
  };

  const handleFinish = () => {
    if (isRunning) {
      setIsRunning(false);
    }
    setFinishModalVisible(true);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
    setSelectedOption(null);
    setTiempoTeorico(null);
  };

  const handleOptionSelect = (option) => {
    setSelectedOption(option);
    setTiempoTeorico(option.tiempos);
  };

  const handleModalAccept = () => {
    if (selectedOption) {
      setModalVisible(false);
      setIsRunning(true);
      let tzoffset = new Date().getTimezoneOffset() * 60000; // Offset en milisegundos
      let localISOTime = new Date(Date.now() - tzoffset)
        .toISOString()
        .slice(0, -1);
      setStartDate(localISOTime);
      setLog(
        SCREEN_IDS.GENERAL,
        "LOG",
        "InicioTiempos",
        "Usuario: " +
          name +
          " Inicio: " +
          localISOTime +
          " Referencia: " +
          mo +
          " Proceso: " +
          selectedOption.name
      );
      saveCronometroState();
    } else {
      notify.warn("Por favor, selecciona una opción antes de continuar.");
    }
  };

  const checkNumberPieceCount = (value) => {
    const num = parseInt(value, 10);
    if (isNaN(num) || num < 0) {
      showAlert(
        "Error",
        "Por favor, ingresa un número válido de piezas terminadas."
      );
      setPieceCount("");
    } else if (num > cantidadRestante) {
      showAlert(
        "Error",
        `No puedes ingresar un número mayor a ${cantidadRestante} piezas restantes.`
      );
      setPieceCount(cantidadRestante.toString());
    } else {
      setPieceCount(value);
    }
  };

  const checkNumberIncident = (value) => {
    const num = parseInt(value, 10);
    const pieceNum = parseInt(pieceCount, 10);
    if (isNaN(num) || num <= 0) {
      notify.warn("Por favor, ingresa un número válido de piezas de incidencia.");
      setIncidenciaCount("");
    } else if (isNaN(pieceNum)) {
      notify.warn("Primero ingresa el número de piezas terminadas.");
      setIncidenciaCount("");
    } else if (num > pieceNum) {
      notify.warn(
        "El número de piezas de incidencia no puede ser mayor que el número de piezas terminadas."
      );
      setIncidenciaCount("");
    } else {
      setIncidenciaCount(value);
    }
  };
  const clearCronometroState = () => {
    localStorage.removeItem("currentCronometro");
    console.log("Estado del cronómetro eliminado.");
  };

  const preguntarSiMarcarComoFinalizado = () => {
    return new Promise((resolve) => {
      setResolverFinalizar(() => resolve); // guardamos el resolver
      setConfirmarFinalizacionVisible(true); // mostramos modal
    });
  };

  const handleStop = async () => {
    if (isProcessing) return;

    const pcs = parseInt(pieceCount, 10);
    let marcarFinalizado = false;

    if (pcs === cantidadRestante) {
      const respuesta = await preguntarSiMarcarComoFinalizado();
      if (respuesta === null) {
        return;
      }
      marcarFinalizado = respuesta;
    }

    // console.log("handleStop called with marcarFinalizado:", marcarFinalizado);
    // return;
    saveCronometroState();
    setIsProcessing(true);

    const serverMin = await getElapsedTimeFromServer(
      currentScreenId,
      "SyncTimeWithServer",
      mo,
      startDate
    );
    const finalElapsed =
      serverMin !== null
        ? serverMin * 60000
        : Date.now() - startTimeRef.current;

    const localElapsed = elapsedTime;

    const durationMs =
      finalElapsed > localElapsed && finalElapsed - localElapsed >= 60000
        ? finalElapsed
        : localElapsed;

    try {
      const piezasPermitidas = cantidadRestante - totalIncidencias;

      if (parseInt(pieceCount, 10) > piezasPermitidas) {
        showAlert(
          "Error",
          `Solo puedes marcar ${piezasPermitidas} piezas como finalizadas debido a las incidencias registradas.`
        );
        setIsProcessing(false);
        return;
      }

      if (showIncidencia) {
        if (!incidenciaCount || !selectedIncidentOption) {
          showAlert(
            "Error",
            "Por favor, completa todos los campos de incidencia antes de continuar."
          );
          setIsProcessing(false);
          return;
        }

        if (parseInt(incidenciaCount, 10) > piezasPermitidas) {
          showAlert(
            "Error",
            `Solo puedes marcar ${piezasPermitidas} piezas como finalizadas debido a las incidencias registradas.`
          );
          setIsProcessing(false);
          return;
        }
      }

      let tzoffset = new Date().getTimezoneOffset() * 60000;
      let localISOTime = new Date(Date.now() - tzoffset)
        .toISOString()
        .slice(0, -1);
      const isoFormattedEndDate = localISOTime;

      const dataToSend = {
        mo: mo,
        user: name,
        team: team,
        process: selectedOption,
        startDate: startDate,
        endDate: isoFormattedEndDate,
        durationMs: durationMs,
        durationFormatted: formatTime(durationMs),
        pieceCount: pieceCount,
        incidencia: selectedIncidentOption ? selectedIncidentOption.id : null,
        incidenciaCount: incidenciaCount,
        selectedIncidentOption: selectedIncidentOption,
        comment: comment,
        marcarFinalizado: marcarFinalizado,
      };

      await insertTimeTimeWork(
        currentScreenId,
        typeConnect[1],
        "cronometroTimeWork",
        dataToSend
      );

      const newInfo = await fullDataPiece(mo, 2);
      const infoData = getArrayInfoDataUpdate(newInfo);
      dispatch(updateInfoData(infoData));

      setFinishModalVisible(false);
      setElapsedTime(0);
      setSelectedOption(null);
      setShowIncidencia(false);
      setPieceCount("");
      setIncidenciaCount("");
      setSelectedIncidentOption(null);
      setStartDate(null);
      setTiempoTeorico(null);
      clearCronometroState();
    } catch (error) {
      console.error("Error cargando datos:", error);
    } finally {
      setIsProcessing(false);
    }
  };

  const isAcceptButtonDisabled = showIncidencia
    ? !incidenciaCount || !selectedIncidentOption
    : false;

  return (
    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
      <CronometroMonitor
        isRunning={isRunning}
        elapsedTime={elapsedTime}
        startDate={startDate}
        mo={mo}
        process={selectedOption}
        user={name}
        team={team}
        saveCallback={() => {
          const cronometroState = {
            isRunning,
            elapsedTime,
            startDate,
            mo,
            process: selectedOption,
            user: name,
            team: team,
          };
          localStorage.setItem(
            "currentCronometro",
            JSON.stringify(cronometroState)
          );
          console.log("Estado del cronómetro guardado:", cronometroState);
        }}
      />

      {/* Botón de iniciar/finalizar */}
      {!isRunning ? (
        <Button
          variant='contained'
          onClick={handleStart}
          sx={{
            mr: 2,
            fontSize: 20,
            flexGrow: 1,
            backgroundColor: backgroundColor2, // Color de fondo del botón Iniciar
            color: SIMPLIFIED_CRONOMETRO_COLORS.TEXT_WHITE, // Color del texto
            "&:hover": {
              backgroundColor: SIMPLIFIED_CRONOMETRO_COLORS.BACKGROUND_HOVER, // Color de fondo al hacer hover
            },
          }}>
          {translateText("Iniciar", lang)}
        </Button>
      ) : (
        <Button
          variant='contained'
          onClick={handleFinish}
          sx={{ mr: 2, fontSize: 20, flexGrow: 1 }}>
          {translateText("Finalizar", lang)}
        </Button>
      )}

      {/* Contador de tiempo */}
      <Box
        sx={{
          backgroundColor: SIMPLIFIED_CRONOMETRO_COLORS.BACKGROUND_LIGHT,
          padding: 1,
          borderRadius: 1,
          minWidth: 100,
          textAlign: "center",
          mr: 2,
          flexGrow: 1,
        }}>
        <Typography variant='h6' sx={{ color: SIMPLIFIED_CRONOMETRO_COLORS.TEXT_BLACK }}>
          {formatTime(elapsedTime)}
        </Typography>
      </Box>

      {tiempoTeorico && (
        <Box
          sx={{
            backgroundColor: SIMPLIFIED_CRONOMETRO_COLORS.BACKGROUND_LIGHT,
            padding: 1,
            borderRadius: 1,
            minWidth: 100,
            textAlign: "center",
            mr: 2,
            flexGrow: 1,
          }}>
          <Typography variant='h6' sx={{ color: SIMPLIFIED_CRONOMETRO_COLORS.TEXT_BLACK }}>
            Standard: {tiempoTeorico ? cantidadRestante * tiempoTeorico : 0} min
          </Typography>
        </Box>
      )}

      <Modal open={modalVisible} onClose={handleModalCancel}>
        <Box
          sx={{
            ...modalStyle,
            display: "flex",
            flexDirection: "column",
            maxHeight: "90vh",
          }}>
          <Typography variant='h6' gutterBottom>
            {translateText("Selecciona una opción", lang)}:
          </Typography>
          {/* Contenedor de la lista que hace scroll */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              maxHeight: "60vh",
              mb: 2,
            }}>
            <List>
              {Options.map((item) => (
                <ListItem key={item.id} disablePadding>
                  <ListItemButton
                    selected={selectedOption && selectedOption.id === item.id}
                    onClick={() => handleOptionSelect(item)}>
                    <ListItemText primary={translateText(item.name, lang)} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Box>
          {/* Botones siempre visibles */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              onClick={handleModalAccept}
              variant='contained'
              disabled={!selectedOption}
              sx={{ mr: 2 }}>
              {translateText("Aceptar", lang)}
            </Button>
            <Button onClick={handleModalCancel} variant='outlined'>
              {translateText("Cancelar", lang)}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal
        open={finishModalVisible}
        onClose={() => setFinishModalVisible(false)}>
        <Box sx={modalStyle}>
          {/* Observación */}
          <Box sx={{ mb: 2 }}>
            <Typography
              variant='h6'
              gutterBottom
              sx={{ display: "flex", alignItems: "center" }}>
              {translateText("Observaciónes", lang)}
            </Typography>
            <Box
              sx={{
                p: 2,
                mb: 2,
                backgroundColor: SIMPLIFIED_CRONOMETRO_COLORS.BACKGROUND_CARD,
                border: `1px solid ${SIMPLIFIED_CRONOMETRO_COLORS.BORDER_LIGHT}`,
                borderRadius: "4px",
                minHeight: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
              <Typography
                variant='body1'
                sx={{ color: SIMPLIFIED_CRONOMETRO_COLORS.TEXT_SECONDARY, flexGrow: 1, wordBreak: "break-word" }}>
                {comment || "Sin observaciones"}
              </Typography>
              <ComponentObservaciones
                onSave={(newComment) => setComment(newComment)}
              />
            </Box>
          </Box>

          <Typography variant='h6' gutterBottom>
            {translateText("Nº de piezas terminadas", lang)}:
          </Typography>
          <Typography variant='body2' gutterBottom>
            ({translateText("Máximo", lang)} {cantidadRestante}{" "}
            {translateText("piezas", lang)})
          </Typography>
          <TextField
            value={pieceCount}
            onChange={(e) => checkNumberPieceCount(e.target.value)}
            type='number'
            variant='outlined'
            fullWidth
            sx={{ mb: 2 }}
          />

          {screen === 8 && (
            <Box>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showIncidencia}
                    onChange={() => setShowIncidencia(!showIncidencia)}
                  />
                }
                label='Incidencia'
              />
              {showIncidencia && (
                <Box>
                  <Typography variant='h6' gutterBottom>
                    {translateText("Nº piezas de incidencia", lang)}:
                  </Typography>
                  <TextField
                    value={incidenciaCount}
                    onChange={(e) => checkNumberIncident(e.target.value)}
                    type='number'
                    variant='outlined'
                    fullWidth
                    sx={{ mb: 2 }}
                  />
                  <Typography variant='h6' gutterBottom>
                    {translateText("Selecciona una opción", lang)}:
                  </Typography>
                  <List
                    sx={{
                      maxHeight: "200px",
                      overflowY: "auto",
                      border: `1px solid ${SIMPLIFIED_CRONOMETRO_COLORS.BORDER_MEDIUM}`,
                      padding: 1,
                    }}>
                    {OptionIncident.map((item) => (
                      <ListItem key={item.id} disablePadding>
                        <ListItemButton
                          selected={
                            selectedIncidentOption &&
                            selectedIncidentOption.id === item.id
                          }
                          onClick={() => setSelectedIncidentOption(item)}>
                          <ListItemText primary={item.name} />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              )}
            </Box>
          )}

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
            <Button
              onClick={handleStop}
              variant='contained'
              disabled={isProcessing || isAcceptButtonDisabled}>
              {translateText("Aceptar", lang)}
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={confirmarFinalizacionVisible} onClose={() => {}}>
        <Box
          sx={{
            ...modalStyle,
            width: "90vw",
            maxWidth: 600,
            textAlign: "center",
            borderRadius: 3,
            padding: 4,
          }}>
          <Typography variant='h6' gutterBottom>
            ¿Qué deseas hacer?
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 3,
              mt: 3,
              flexWrap: "wrap",
            }}>
            {/* Tarjeta 1 */}
            <Box
              onClick={() => {
                setConfirmarFinalizacionVisible(false);
                resolverFinalizar(false);
              }}
              sx={{
                width: 220,
                height: 100,
                cursor: "pointer",
                backgroundColor: BACKGROUND_COLORS.CARD,
                borderRadius: 2,
                border: `2px solid ${BRAND_COLORS.PRIMARY}`,
                color: BRAND_COLORS.PRIMARY,
                fontWeight: "bold",
                fontSize: "16px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: 3,
                textAlign: "center",
                "&:hover": {
                  backgroundColor: BACKGROUND_COLORS.SECONDARY,
                },
              }}>
              <Typography fontSize={36} mb={1}>
                ⏱
              </Typography>
              <Typography fontWeight='bold'>PAUSAR TIEMPO</Typography>
            </Box>

            <Box
              onClick={() => {
                setConfirmarFinalizacionVisible(false);
                resolverFinalizar(true);
              }}
              sx={{
                width: 220,
                height: 100,
                cursor: "pointer",
                backgroundColor: BRAND_COLORS.PRIMARY,
                borderRadius: 2,
                color: BACKGROUND_COLORS.CARD,
                fontWeight: "bold",
                fontSize: "16px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: 3,
                textAlign: "center",
                "&:hover": {
                  backgroundColor: BRAND_COLORS.PRIMARY_DARK,
                },
              }}>
              <Typography fontSize={36} mb={1}>
                ⚠️
              </Typography>
              <Typography fontWeight='bold'> FINALIZAR PROCESO</Typography>
            </Box>
          </Box>

          <Button
            variant='text'
            sx={{
              mt: 4,
              color: STATUS_COLORS.ERROR,
              fontWeight: "bold",
              fontSize: "16px",
            }}
            onClick={() => {
              setConfirmarFinalizacionVisible(false);
              resolverFinalizar(null);
            }}>
            CANCELAR
          </Button>
        </Box>
      </Modal>
    </Box>
  );
};

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  maxHeight: "80%",
  overflowY: "auto",
};

export default SimplifiedCronometro;
